import type { AgentRosterEntry } from 'types/agents';
import { agentRealName } from 'types/agents';
import { AgentStatusBadge } from './AgentStatusBadge';

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export function AgentCard({
  entry,
  canEdit,
  onSelect,
  onEdit,
}: {
  entry: AgentRosterEntry;
  canEdit?: boolean;
  onSelect: () => void;
  onEdit?: () => void;
}) {
  const name = agentRealName(entry);
  const isFull = entry.load.max > 0 && entry.load.active >= entry.load.max;
  const pct =
    entry.load.max > 0 ? Math.min(100, Math.round((entry.load.active / entry.load.max) * 100)) : 0;

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3">
      <div className="flex items-center justify-between">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50 text-xs font-medium text-blue-700">
          {initialsOf(name)}
        </div>
        <AgentStatusBadge status={entry.derivedStatus} />
      </div>

      <button type="button" onClick={onSelect} className="mt-2 block w-full text-left">
        <div className="truncate text-sm font-medium text-gray-950">{name}</div>
        <div className="mt-0.5 truncate text-xs text-blue-600">alias: {entry.alias}</div>
      </button>

      <div className="mt-2 text-[11px] text-gray-500">
        {entry.load.active} av {entry.load.max} chattar{isFull ? ' · fullt' : ''}
      </div>
      <div className="mt-1 h-1 w-full overflow-hidden rounded-full bg-gray-100">
        <div
          className={`h-full ${isFull ? 'bg-amber-500' : 'bg-green-500'}`}
          style={{ width: `${pct}%` }}
        />
      </div>

      {canEdit && onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="mt-2 text-xs font-medium text-gray-500 hover:text-gray-800"
        >
          Redigera
        </button>
      )}
    </div>
  );
}
